import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

function EmptyUsersState() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: "center",
        py: 8,
        px: 3,
        bgcolor: theme.palette.background.paper,
        borderRadius: 2,
        border: `1px dashed ${theme.palette.divider}`,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontSize: 64,
          color: theme.palette.text.disabled,
          mb: 2,
        }}
      >
        👥
      </Typography>
      <Typography
        variant="h5"
        sx={{
          mb: 1,
          fontWeight: 600,
          color: theme.palette.text.primary,
        }}
      >
        {t("myUserManagement.noUsersTitle")}
      </Typography>
      <Typography variant="body2" color="text.disabled">
        {t("myUserManagement.noUsersFound")}
      </Typography>
    </Box>
  );
}

export default EmptyUsersState;
